import React from "react";
import { Modal, Row, Col, Typography } from "antd";
import Lottie from "react-lottie";
import * as animationData from "./LoadingLottie.json";
const { Title, Text } = Typography;
export default function LoadingModal({ loading,selectedProdutcs }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData.default,
    //animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <Modal
      visible={loading}
      closable={false}
      closeIcon={null}
      footer={null}
      bodyStyle={{ padding: "3rem" }}
      centered
    >
      <Row justify="center">
        <Lottie
          options={defaultOptions}
          height={"100%"}
          width={"100%"}
          //   isStopped={loading}
          //   isPaused={loading}
        />

        <Col style={{textAlign:'center'}}>
          <Title level={3}>Scanning data for {`${selectedProdutcs?.length}`} products</Title>
          <Text>
            Creating the table might take a few minutes, please be patient and do
            not close this window until it’s complete
          </Text>
        </Col>
      </Row>
    </Modal>
  );
}
